var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell large-10",staticStyle:{"text-align":"center","padding":"5px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }